import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-ecd0d662"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-list" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("th", null, "类型"),
  /*#__PURE__*/_createElementVNode("th", null, "名称"),
  /*#__PURE__*/_createElementVNode("th", null, "大小"),
  /*#__PURE__*/_createElementVNode("th", null, "说明")
], -1))
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "链接", -1))
const _hoisted_6 = ["onClick", "href"]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "文件", -1))
const _hoisted_10 = ["onClick", "href"]


import {UserCourseLivePage} from "@/models/live/userCourseLivePage";
import { fetchCommitLivePageUseTime } from "@/apis/live";

//eslint-disable-next-line @typescript-eslint/no-unused-vars

export default /*#__PURE__*/_defineComponent({
  __name: 'MainLiveFileList',
  props: {
    title: {},
    pages: {}
  },
  setup(__props: any) {

const props = __props

const commitLivePageUseTime = (pageId:number) => {
  fetchCommitLivePageUseTime(pageId).then(res=>{
    console.log(res);
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1),
    _createElementVNode("table", null, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pages, (page) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: 'page' + page.id
        }, [
          (page.page?.type === 'link')
            ? (_openBlock(), _createElementBlock("tr", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("td", null, [
                  _createElementVNode("a", {
                    onClick: ($event: any) => (commitLivePageUseTime(page.id)),
                    href: page.page.path,
                    target: "_blank"
                  }, _toDisplayString(page.page.title), 9, _hoisted_6)
                ]),
                _hoisted_7,
                _createElementVNode("td", null, _toDisplayString(page.page.desc), 1)
              ]))
            : (page.page?.type === 'download')
              ? (_openBlock(), _createElementBlock("tr", _hoisted_8, [
                  _hoisted_9,
                  _createElementVNode("td", null, [
                    _createElementVNode("a", {
                      onClick: ($event: any) => (commitLivePageUseTime(page.id)),
                      href: page.page.path,
                      target: "_blank"
                    }, _toDisplayString(page.page.filename), 9, _hoisted_10)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(page.page.size || '未知大小'), 1),
                  _createElementVNode("td", null, _toDisplayString(page.page.desc), 1)
                ]))
              : _createCommentVNode("", true)
        ], 64))
      }), 128))
    ])
  ]))
}
}

})